export const breakpoints = {
	isExtraSmall: () => {
		return window.innerWidth < 421;
	},
	isSmall: () => {
		return window.innerWidth < 641;
	},
	isMedium: () => {
		return window.innerWidth < 941;
	},
	isIpad: () => {
		return window.innerWidth < 1025;
	},
	isLarge: () => {
		return window.innerWidth < 1241;
	},
	isExtraLarge: () => {
		return window.innerWidth > 1240;
	}
};

